import { WmButton } from "@watermarkinsights/ripple-react";
import translate from "../../../i18n/translate";
import { useEffect, useReducer } from "react";
import { downloadPDF } from "../../common/helper";
import { sendRequest, sendRequestWithPayload } from "../../../common/http";
import useIntl from "react-intl/src/components/useIntl";

export interface HeaderProps {
  reportingYear: string;
  showDownloadBtn: boolean;
}

interface TokenResultSet {
  token: string;
}

interface ExportResultSet {
  pdf_file_bytes: string;
}
interface Action {
  type: string;
  token: string | null;
  data: boolean;
}
const defaultAction = {
  type: "",
  token: "",
  data: false
};
interface HeaderState {
  token: string | null;
  isExportInProgress: boolean;
}
const reducer = (state: HeaderState, action: Action) => {
  switch (action.type) {
    case "setToken":
      return { ...state, token: action.token };
    case "setExportInProgress":
      return { ...state, isExportInProgress: action.data };
    default:
      return state;
  }
};
const initialState: HeaderState = {
  token: null,
  isExportInProgress: false
};

export default function Header({
  reportingYear,
  showDownloadBtn
}: HeaderProps): JSX.Element {
  const subHeader = useIntl().formatMessage({
    id: "app.sll.learningAssessment"
  });
  const [state, dispatch] = useReducer(reducer, initialState);
  function exportToPdf() {
    let sllHtml = document.getElementById("sll-html");
    let downloadText = document.querySelector(".download-text");
    if (downloadText) {
      downloadText.setAttribute("tabindex", "0");
      (downloadText as HTMLElement).focus();
    }

    if (sllHtml) {
      let clone = sllHtml.cloneNode(true);
      let headerSection = clone.firstChild;
      headerSection && clone.removeChild(headerSection);
      let wrapperMain = document.createElement("main");
      wrapperMain.classList.add("main-container");
      wrapperMain.appendChild(clone);

      let wrapperDiv = document.createElement("div");
      wrapperDiv.appendChild(wrapperMain);

      let formData = new FormData();
      formData.append("html", wrapperDiv.outerHTML);
      formData.append("sub_header", subHeader);
      formData.append("header", reportingYear);
      formData.append("export_id", "learning-assessments-export")
      formData.append("_csrf_token", state.token ? state.token : "");

      const applyResult = (result: ExportResultSet) => {
        downloadPDF(result.pdf_file_bytes, "Learning_Assessments_Insights");
        dispatch({ ...defaultAction, type: "setToken", token: null });
        dispatch({
          ...defaultAction,
          type: "setExportInProgress",
          data: false
        });
      };
      const onError = () => {
        dispatch({ ...defaultAction, type: "setToken", token: null });
        dispatch({
          ...defaultAction,
          type: "setExportInProgress",
          data: false
        });
      };
      sendRequestWithPayload(
        {
          uri: "/export",
          body: formData
        },
        applyResult,
        onError
      );
    }
  }

  useEffect(() => {
    if (state.isExportInProgress) {
      sendRequest(
        {
          uri: "/export/token",
          camelize: true
        },
        (result: TokenResultSet) => {
          dispatch({
            ...defaultAction,
            type: "setToken",
            token: result.token
          });
        }
      );
    }
  }, [state.isExportInProgress]);
  useEffect(() => {
    if (state.token && state.isExportInProgress) {
      exportToPdf();
    }
  }, [state.isExportInProgress, state.token]);
  return (
    <>
      <section
        className="page-banner-container -mainheader -withbreadcrumbs only-breadcrumbs header-padding"
        id="page-header"
      >
        <div className="flex-row export-container">
          <div>
            <div>
              <span className="org-name uppercase">
                {subHeader}
              </span>
            </div>
            <div className="identity-details">
              <div className="page-header -titleonly">
                <h2 id="main-heading" className="plan-title-header">{reportingYear}</h2>
              </div>
            </div>
          </div>
          {showDownloadBtn && (
            <div className="flex-row export-button">
              {state.isExportInProgress && (
                <span className="download-text">
                  {translate(
                    "app.planParticipation.exportPdf.downloadReportText"
                  )}
                </span>
              )}
              <div className="button-container">
                <WmButton
                  button-type="secondary"
                  icon="f1da"
                  icon-size="20px"
                  onClick={() =>
                    dispatch({
                      ...defaultAction,
                      type: "setExportInProgress",
                      data: true
                    })
                  }
                  disabled={state.isExportInProgress}
                >
                  {translate("app.downloadHtml")}
                </WmButton>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
